import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface WorkPackages {
  readonly site: number;
  readonly discipline: number;
  readonly workPackageName: string;
  readonly workPackageId: string;
  readonly workPackageStatus: string;
  readonly workPackageStatusId: number;
  readonly noOfInspections: number;
  readonly inspectorId: string;
  readonly isActive: boolean;
  readonly dateModified: string;
  readonly dateCreated: string;
  readonly isLeadInspector: boolean;
  readonly isAdhoc: boolean;
}

export const workPackagesSchema: RxJsonSchema<WorkPackages> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'workPackageId',
  properties: {
    workPackageId: { type: 'string', maxLength: 36 },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    workPackageName: { type: ['string', 'null'] },
    workPackageStatus: { type: ['string', 'null'] },
    workPackageStatusId: { type: ['number', 'null'] },
    noOfInspections: { type: ['number', 'null'] },
    inspectorId: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    isLeadInspector: { type: ['boolean', 'null'] },
    isAdhoc: { type: ['boolean', 'null'] },
  },
};

export type WorkPackagesCollection = RxCollection<WorkPackages> | null;
export type WorkPackagesDocument = RxDocument<WorkPackages>;

export const workPackagesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: WorkPackagesDocument) => ({ ...oldDoc, isAdhoc: false }),
};

export const workPackagesPullQueryBuilder = (document: WorkPackages) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mobileWorkPackageFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileWorkPackageFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        isAdhoc
        site
        discipline
        workPackageName
        workPackageId
        workPackageStatus
        workPackageStatusId
        noOfInspections
        inspectorId
        isActive
        dateModified
        dateCreated
        isLeadInspector
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export default {};
